function read_more_less() {
 var dots = document.getElementById('dots');
  var moretext = document.getElementById('more');
  var mybtn = document.getElementById('myBtn');
  if (moretext.style.display === 'none') {
    moretext.style.display = 'inline';
    mybtn.innerHTML = "Show Less";
  } else {
    moretext.style.display = 'none';
    mybtn.innerHTML = "Show More";
}
}